import React from "react";
import { TouchableOpacity } from "react-native";
import { useComponentEditor } from "../context/ComponentEditorContext";

class BaseComponent extends React.Component {
	constructor(props) {
		super(props);
		this.componentType = this.constructor.name;

		// Initialize state with default editable properties
		try {
			const { properties = {} } = this.getEditableProperties() || {};
			this.state = {
				editableProps: this.extractInitialValues(properties),
			};
		} catch (error) {
			console.warn(`Error initializing state for ${this.componentType}:`, error);
			this.state = { editableProps: {} };
		}
	}

	// Extract initial values from properties definition
	extractInitialValues(properties) {
		const initialValues = {};

		if (!properties) return initialValues;

		Object.entries(properties).forEach(([key, property]) => {
			if (!property) return;

			if (property.type === "group" && property.properties) {
				// For group type, extract values from nested properties
				const groupValues = {};
				Object.entries(property.properties).forEach(([nestedKey, nestedProp]) => {
					if (nestedProp && nestedProp.value !== undefined) {
						groupValues[nestedKey] = nestedProp.value;
					}
				});
				initialValues[key] = groupValues;
			} else if (property.value !== undefined) {
				// For other types, just take the value
				initialValues[key] = property.value;
			}
		});

		return initialValues;
	}

	// Update a property value in state
	updateProperty = (propertyKey, value) => {
		this.setState(
			(prevState) => {
				const newEditableProps = { ...prevState.editableProps };
				newEditableProps[propertyKey] = value;
				return { editableProps: newEditableProps };
			},
			() => {}
		);
	};

	// Get current property value from state
	getPropertyValue(propertyKey) {
		return this.state?.editableProps?.[propertyKey];
	}

	handlePress = () => {
		if (this.props.onComponentSelect) {
			this.props.onComponentSelect(this);
		}
	};

	// This method should be overridden by child components to define their editable properties
	getEditableProperties() {
		return {
			sections: [], // Array of section definitions
			properties: {}, // Object containing property definitions
		};
	}

	renderContent() {
		// This method should be overridden by child components
		return null;
	}

	render() {
		return (
			<TouchableOpacity onPress={this.handlePress} activeOpacity={0.8}>
				{this.renderContent()}
			</TouchableOpacity>
		);
	}
}

// Wrapper to provide component editor context
export const withComponentEditor = (WrappedComponent) => {
	return (props) => {
		const { setSelectedComponent } = useComponentEditor();

		const handleComponentSelect = (component) => {
			// Pass the actual component instance to the context
			setSelectedComponent(component);
		};

		return <WrappedComponent {...props} onComponentSelect={handleComponentSelect} />;
	};
};

export default BaseComponent;
